import { resolveFileUrl } from "../urlHelpers.js"
import { jsenvBundlingDirectoryUrl } from "../jsenvBundlingDirectoryUrl.js"
import { createImportMetaUrlNamedImportBabelPlugin } from "./createImportMetaUrlNamedImportBabelPlugin.js"

export const generateBabelPluginMapOption = ({
  format,
  babelPluginMap,
  babelPluginRequiredNameArray,
}) => {
  return {
    ...generateBabelPluginMapSubset({
      babelPluginMap,
      babelPluginRequiredNameArray,
    }),
    ...generateBabelPluginMapForBundle({
      format,
    }),
  }
}

const generateBabelPluginMapSubset = ({ babelPluginMap, babelPluginRequiredNameArray }) => {
  const babelPluginMapSubset = {}

  Object.keys(babelPluginMap).forEach((babelPluginName) => {
    if (babelPluginRequiredNameArray.includes(babelPluginName)) {
      babelPluginMapSubset[babelPluginName] = babelPluginMap[babelPluginName]
    }
  })

  return babelPluginMapSubset
}

const generateBabelPluginMapForBundle = ({ format }) => {
  const bundleBabelPluginMap = {}

  if (format === "commonjs" || format === "global") {
    const importMetaFacadeUrl = resolveFileUrl(
      `./src/generateBabelPluginMapOption/import-meta-${format}.js`,
      jsenvBundlingDirectoryUrl,
    )

    bundleBabelPluginMap[
      "import-meta-url-named-import"
    ] = createImportMetaUrlNamedImportBabelPlugin({
      importMetaFacadeUrl,
    })
  }

  return bundleBabelPluginMap
}
